import {createFileRoute} from '@tanstack/react-router';

import {parseNonEmpty} from '@/lib/search-params';
import {PhotoReportTemplatesPage} from '@/modules/photo-report-templates/pages/PhotoReportTemplatesPage';
import type {TemplateTypeValue} from '@/modules/photo-report-templates/lib/types';

/**
 * URL state for the report-templates page: the active Photo Report / JAC tab and
 * the name search. Both optional so external links can navigate here without
 * specifying them; the page falls back to `tab ?? "photo_report"`.
 */
export interface TemplatesListSearch {
  tab?: TemplateTypeValue;
  q?: string;
}

const TAB_VALUES: ReadonlyArray<TemplateTypeValue> = ['photo_report', 'jac'];

function parseTab(value: unknown): TemplateTypeValue | undefined {
  return TAB_VALUES.find((t) => t === value);
}

const validateTemplatesListSearch = (search: Record<string, unknown>): TemplatesListSearch => ({
  tab: parseTab(search.tab),
  q: parseNonEmpty(search.q),
});

export const Route = createFileRoute('/_authenticated/photo-report-templates/')({
  validateSearch: validateTemplatesListSearch,
  component: PhotoReportTemplatesPage,
});
